const PERMISSION_KEY= "core:api_key_permission_mapping";
const PAGE_URL = {
    API_KEY_PERMISSION_MAPPING_PAGE: "/admin/core/api-key-permission-mapping"
}

export {PERMISSION_KEY, PAGE_URL}

